package nl.astraeus.wiki.messages

class UpdatePageOrderMessage() : Message(
  MessageType.UPDATE_PAGE_ORDER,
  MessageHeader.WIKI_ID,
  MessageHeader.PAGE_IDS,
) {

  constructor(msg: String) : this() {
    message = msg
    checkType(MessageType.UPDATE_PAGE_ORDER)
  }

  constructor(wikiId: Long, pageIds: List<Long>) : this() {
    setHeader(MessageHeader.WIKI_ID, wikiId.toString())
    setHeader(MessageHeader.PAGE_IDS, pageIds.joinToString(","))
  }
}
